import clsx from 'clsx'

interface Props {
  status: string
  isCreatedProject: boolean
}

const StatusCell: React.FC<Props> = ({ status, isCreatedProject }) => {
  const findStatus = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'planning':
        return 'Planning'
      case 'in-progress':
        return 'กำลังสำรวจ'
      case 'hold':
        return 'อยู่ในช่วงพักการสำรวจ'
      case 'cancel':
        return 'ยกเลิกการสำรวจพื้นที่'
      case 'completed':
        return 'สำรวจเสร็จสิ้น'
      default:
        return ''
    }
  }

  const findColor = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'in-progress':
        return 'badge-primary'
      case 'hold':
        return 'badge-warning'
      case 'cancel':
        return 'badge-danger'
      case 'completed':
        return 'badge-success'
      default:
        return ''
    }
  }

  return (
    <>
      {status && status.toLowerCase() !== '' ? (
        <span className={`badge ${findColor(status)}`}>{findStatus(status)}</span>
      ) : null}

      {isCreatedProject && (
        <span
          className={clsx('badge badge-success', {
            'ms-4': status && status.toLowerCase() !== '',
          })}>
          สร้างโครงการแล้ว
        </span>
      )}
    </>
  )
}

export default StatusCell
